import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'

import {
  GALLERY_WIDTH,
  TOP_SECTION_MIN_HEIGHT
} from '../HotelCardLayout/HotelCardLayout'

export const GalleryLoading = () => {
  return (
    <Box width="100%" height="100%" overflow="hidden" position="relative">
      <Box width={`${GALLERY_WIDTH}px`} height={`${TOP_SECTION_MIN_HEIGHT}px`}>
        <SkeletonLoader height="100%" />
      </Box>
    </Box>
  )
}
